import React, { useCallback } from 'react';
import { LayoutGrid, List } from 'lucide-react';
import { ToggleWrapper, ToggleIcon } from '../styles/PackageIndexStyles';

const options = [
  { value: 'grid', icon: LayoutGrid, label: 'Grid View' },
  { value: 'list', icon: List, label: 'List View' },
];

const LayoutToggle = ({ layout, setLayout }) => {
  const handleClick = useCallback((view) => {
    setLayout(view);
  }, [setLayout]);

  const handleKeyDown = useCallback((e, view) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      setLayout(view);
    }
  }, [setLayout]);

  return (
    <ToggleWrapper>
      {options.map(({ value, icon: Icon, label }) => (
        <ToggleIcon
          key={value}
          onClick={() => handleClick(value)}
          onKeyDown={(e) => handleKeyDown(e, value)}
          tabIndex={0}
          role="radio"
          aria-checked={layout === value}
          aria-label={label}
          $active={layout === value}
          title={label}
        >
          <Icon size={20} />
        </ToggleIcon>
      ))}
    </ToggleWrapper>
  );
};

export default React.memo(LayoutToggle);
